import { Routes, Route, Navigate, useParams, useLocation } from 'react-router-dom';
import { useCRMAuth } from './context/CRMAuthContext';
import { CRMLayout } from './components/CRMLayout';
import { CRMRoute } from './components/CRMRoute';
import CRMLogin from './pages/CRMLogin';
import CRMDashboard from './pages/CRMDashboard';
import CRMUsers from './pages/CRMUsers';
import CRMProfile from './pages/CRMProfile';
import CRMCustomers from './pages/CRMCustomerRecords';
import CRMCustomerDetail from './pages/CRMCustomerRecord';
import CRMPendingCustomers from './pages/CRMPendingCustomers';
import CRMLeadRecords from './pages/CRMLeadRecords';
import CRMLeadRecord from './pages/CRMLeadRecord';
import CRMDataLists from './pages/CRMDataLists';
import CRMAssignment from './pages/CRMAssignment';
import CRMDeposits from './pages/CRMDeposits';
import CRMWithdrawals from './pages/CRMWithdrawals';
import CRMTransfers from './pages/CRMTransfers';
import CRMBrokerAccounts from './pages/CRMBrokerAccounts';
import CRMNotifications from './pages/CRMNotifications';
import CRMReferences from './pages/CRMReferences';
import CRMTags from './pages/CRMTags';
import CRMTeamReport from './pages/CRMTeamReport';
import './crm.css';

const RecordRoute = ({ kind }) => {
  const { id } = useParams();
  return <CRMRoute moduleId={kind} record={`/${kind}/${encodeURIComponent(id)}`} />;
};
const ProtectedWorkspace = () => {
  const { user } = useCRMAuth();
  const location = useLocation();
  if (!user) return <Navigate to="/crm/login" state={{ from: location.pathname }} replace />;
  return <CRMLayout><Routes>
    <Route index element={<CRMRoute moduleId="dashboard"><CRMDashboard /></CRMRoute>} />
    <Route path="settings/users" element={<CRMRoute moduleId="users"><CRMUsers /></CRMRoute>} />
    <Route path="profile" element={<CRMRoute moduleId="profile"><CRMProfile /></CRMRoute>} />
    <Route path="team-reports" element={<CRMRoute moduleId="team-reports"><CRMTeamReport /></CRMRoute>} />
    <Route path="customers" element={<CRMRoute moduleId="customers"><CRMCustomers /></CRMRoute>} />
    <Route path="customers/pending" element={<CRMRoute moduleId="pending"><CRMPendingCustomers /></CRMRoute>} />
    <Route path="tags" element={<CRMRoute moduleId="tags"><CRMTags /></CRMRoute>} />
    <Route path="customers/:id" element={<CRMRoute moduleId="customers"><CRMCustomerDetail /></CRMRoute>} />
    <Route path="leads" element={<CRMRoute moduleId="leads"><CRMLeadRecords /></CRMRoute>} />
    <Route path="leads/:id" element={<CRMRoute moduleId="leads"><CRMLeadRecord /></CRMRoute>} />
    <Route path="data-lists" element={<CRMRoute moduleId="data-lists"><CRMDataLists /></CRMRoute>} />
    <Route path="assignment" element={<CRMRoute moduleId="assignment"><CRMAssignment /></CRMRoute>} />
    <Route path="financial/deposits" element={<CRMRoute moduleId="deposits"><CRMDeposits /></CRMRoute>} />
    <Route path="financial/withdrawals" element={<CRMRoute moduleId="withdrawals"><CRMWithdrawals /></CRMRoute>} />
    <Route path="financial/transfers" element={<CRMRoute moduleId="transfers"><CRMTransfers /></CRMRoute>} />
    <Route path="settings/banks" element={<CRMRoute moduleId="banks"><CRMBrokerAccounts /></CRMRoute>} />
    <Route path="notifications" element={<CRMRoute moduleId="notifications"><CRMNotifications /></CRMRoute>} />
    <Route path="references" element={<CRMRoute moduleId="references"><CRMReferences /></CRMRoute>} />
    <Route path="*" element={<CRMRoute moduleId="unknown" />} />
  </Routes></CRMLayout>;
};
const CRMRoutes = () => {
  const { loading } = useCRMAuth();
  if (loading) return <div className="crm-empty" data-testid="crm-session-loading">Oturum kontrol ediliyor…</div>;
  return <Routes><Route path="login" element={<CRMLogin destination="/crm" />} /><Route path="*" element={<ProtectedWorkspace />} /></Routes>;
};
export default function CRMApp() {
  return <div className="crm-root" lang="tr"><CRMRoutes /></div>;
}